export default {
  nav: {
    careers: 'Careers',
    admin: 'Admin',
    backToStore: 'Back to Store',
    results: 'Results'
  },
  hero: {
    badge: 'We\'re Hiring',
    title: 'Who We Are?',
    goal: 'Our Goal',
    seeMore: 'See more',
    seeLess: 'See less',
    subtitle: `A company focused on continuous growth and development. Technology is not just a product — it is an opportunity that simplifies everyday life, accelerates processes, and makes them more efficient. Our goal is to create a trusted, modern, and customer-centric technology ecosystem where quality, transparency, and professionalism come first.`,
    stats: {
      teamCount: '150000+',
      team: 'Customers',
      locationsCount: '50+',
      locations: 'Team Members',
      openRolesCount: '20+',
      openRoles: 'Branches'
    }
  },
  careers: {
    title: 'Open Positions',
    subtitle: 'Turn Your Ambition into Innovation',
    filters: {
      all: 'All'
    },
    departments: {
      engineering: 'Engineering',
      design: 'Design',
      marketing: 'Marketing'
    },
    salary: 'Salary',
    viewDetails: 'View Details',
    sendResume: 'Send Resume',
    applicants: 'applicants',
    deadline: 'Deadline',
    positionClosed: 'Position Closed',
    noVacancies: 'No open positions at the moment. Check back soon!',
    loading: 'Loading vacancies...',
    status: {
      open: 'Open',
      'closing-soon': 'Closing Soon',
      closed: 'Closed'
    },
    warnings: {
      contact: 'Please note that we will only contact selected candidates.',
      consent: 'By submitting your resume, you automatically agree that Gstore may process, store, and use your personal data in accordance with applicable law, for the specified purpose and period.'
    },
    introduce: {
      title: 'Introduce Yourself',
      description: 'Didn’t find a vacancy that suits you but still think we need you? Then introduce yourself.',
      button: 'Introduce'
    }
  },
  vacancyDetails: {
    title: 'Job Details',
    description: 'Job Description',
    salary: 'Salary',
    responsibilities: 'Key Responsibilities',
    requirements: 'Requirements',
    benefits: 'What We Offer',
    posted: 'Posted on',
    deadline: 'Application Deadline',
    applyNow: 'Send Resume',
    resp1: 'Lead and manage projects from conception to completion',
    resp2: 'Collaborate with cross-functional teams to achieve business objectives',
    resp3: 'Develop and implement strategic initiatives to drive growth',
    resp4: 'Mentor and guide team members to enhance their skills',
    resp5: 'Monitor performance metrics and provide regular reports',
    req1: 'Bachelor\'s degree in relevant field or equivalent experience',
    req2: '3+ years of experience in a similar role',
    req3: 'Strong communication and interpersonal skills',
    req4: 'Proven track record of delivering results',
    req5: 'Ability to work in a fast-paced environment',
    benefit1: 'Competitive salary and performance bonuses',
    benefit2: 'Comprehensive health insurance coverage',
    benefit3: 'Flexible working hours and remote work options',
    benefit4: 'Professional development and training opportunities',
    benefit5: 'Collaborative and inclusive work environment'
  },
  applyModal: {
    title: 'Apply for Position',
    name: 'Full Name',
    email: 'Email Address',
    phone: 'Phone Number',
    position: 'Position',
    selectPosition: 'Select a position',
    desiredPosition: 'Desired Position',
    desiredPositionPlaceholder: 'e.g. Product Manager',
    location: 'Location',
    selectLocation: 'Select a location',
    employmentType: 'Employment Type',
    selectEmploymentType: 'Select an employment type',
    salaryMin: 'Minimum Salary',
    salaryMax: 'Maximum Salary',
    locationOptions: {
      onsite: 'On-site',
      hybrid: 'Hybrid',
      remote: 'Remote'
    },
    employment: {
      fullTime: 'Full-Time',
      partTime: 'Part-Time',
      project: 'Project'
    },
    resume: 'Upload Resume (PDF)',
    coverLetter: 'Cover Letter',
    coverLetterPlaceholder: 'Tell us why you\'re a great fit for this position...',
    submit: 'Submit Application',
    submitting: 'Submitting...',
    cancel: 'Cancel',
    successTitle: 'Application Submitted!',
    success: 'Thank you for applying. We will review your application and get back to you soon.',
    error: 'Failed to submit application. Please try again.'
  },
  admin: {
    tabs: {
      applications: 'Applications',
      selection: 'Selection',
      status: 'Status',
      vacancies: 'Vacancies',
      blueprints: 'Blueprints',
      settings: 'Settings'
    },
    applications: {
      title: 'Job Applications',
      stats: {
        total: 'Total Applications',
        thisMonth: 'This Month',
        thisWeek: 'This Week',
        general: 'Introduce Yourself',
        perVacancy: 'Applications per Vacancy',
        accepted: 'Accepted',
        rejected: 'Rejected',
        pending: 'Pending',
        deleted: 'Deleted'
      },
      filters: {
        allVacancies: 'All Vacancies',
        general: 'Introduce Yourself',
        dateFrom: 'From Date',
        dateTo: 'To Date',
        search: 'Search by name or email...',
        searchLabel: 'Search',
        vacancyLabel: 'Vacancy',
        dateFromLabel: 'Date From',
        dateToLabel: 'Date To',
        sortBy: 'Sort By',
        dateNewest: 'Newest First',
        dateOldest: 'Oldest First',
        nameAsc: 'Name (A-Z)',
        nameDesc: 'Name (Z-A)',
        accepted: 'Accepted',
        rejected: 'Rejected',
        deleted: 'Deleted',
        activeFilters: 'Active filters',
        none: 'None',
        resetFilters: 'Reset Filters'
      },
      table: {
        name: 'Name',
        email: 'Email',
        phone: 'Phone',
        vacancy: 'Position',
        assignedPosition: 'Assigned Position',
        date: 'Submitted',
        resume: 'Resume',
        coverLetter: 'Cover Letter',
        download: 'Download',
        downloadResume: 'Download Resume',
        view: 'View',
        actions: 'Actions'
      },
      selected: 'selected',
      bulkDownload: 'Bulk Download',
      bulkDelete: 'Bulk Delete',
      bulkDeleteConfirm: 'Are you sure you want to delete the selected applications?',
      deleteConfirm: 'Are you sure you want to delete this application?',
      generalTitle: 'Introduce Yourself',
      viewTitle: 'Application Details',
      assignment: {
        title: 'Assign position',
        label: 'Select active vacancy',
        placeholder: 'Choose a vacancy',
        confirm: 'Assign',
        required: 'Please select a vacancy.',
        edit: 'Change assigned position',
        noActiveVacancies: 'No active vacancies available.'
      },
      details: {
        desiredPosition: 'Desired Position',
        locationPreference: 'Location Preference',
        employmentType: 'Employment Type',
        salaryMin: 'Minimum Salary',
        salaryMax: 'Maximum Salary'
      },
      actions: {
        view: 'View',
        download: 'Download',
        accept: 'Accept',
        reject: 'Reject',
        delete: 'Delete',
        export: 'Export',
        restore: 'Restore',
        confirmStatusTitle: 'Confirm status change',
        confirmStatus: 'Set {{count}} application(s) to {{status}}?',
        confirmDeleteTitle: 'Confirm delete',
        confirmDelete: 'Delete {{count}} application(s)?',
        deletePermanently: 'Delete permanently (no 30-day hold)',
        confirm: 'Confirm',
        statusUpdated: 'Status updated to {{status}}.',
        deleted: 'Application deleted.',
        deletedPermanent: 'Application permanently deleted.',
        downloaded: 'Download complete.',
        downloadError: 'Failed to download resume.',
        exported: 'Export ready.',
        noResume: 'No resume attached.',
        actionFailed: 'Action failed. Please try again.',
        loading: 'Loading more...',
        endOfList: 'No more applications.',
        exportError: 'Failed to export applications.',
        comingSoon: 'This action is coming soon.'
      },
      status: {
        pending: 'Pending',
        accepted: 'Accepted',
        rejected: 'Rejected',
        deleted: 'Deleted'
      },
      noApplications: 'No applications found'
    },
    vacancies: {
      title: 'Manage Vacancies',
      addNew: 'Add New Vacancy',
      edit: 'Edit',
      delete: 'Delete',
      deleteConfirm: 'Are you sure you want to delete this vacancy?',
      posted: 'Posted',
      deadline: 'Deadline',
      applicants: 'applicants',
      expired: 'Expired',
      closingSoon: 'Closing Soon',
      noVacancies: 'No vacancies found',
      status: {
        open: 'Open',
        'closing-soon': 'Closing Soon',
        closed: 'Closed'
      },
      form: {
        title: 'Job Title',
        department: 'Department',
        location: 'Location',
        type: 'Employment Type',
        status: 'Status',
        deadline: 'Application Deadline',
        salaryRange: 'Salary Range',
        salaryMin: 'Minimum Salary',
        salaryMax: 'Maximum Salary',
        currency: 'Currency',
        description: 'Job Description',
        descriptionPlaceholder: 'Describe the role and responsibilities...',
        responsibilities: 'Key Responsibilities',
        responsibilityPlaceholder: 'Add a responsibility',
        requirements: 'Requirements',
        requirementPlaceholder: 'Add a requirement',
        benefits: 'Benefits',
        benefitPlaceholder: 'Add a benefit',
        visitLocation: 'Visit location (Google Maps link)',
        visitLocationPlaceholder: 'Paste a Google Maps link or address',
        createBlank: 'Create from blank',
        createFromBlueprint: 'Create from blueprint',
        selectBlueprint: 'Select vacancy blueprint',
        selectBlueprintPlaceholder: 'Choose a blueprint',
        saveBlueprint: 'Save as blueprint',
        blueprintNamePlaceholder: 'Blueprint name (unique)',
        addItem: 'Add',
        save: 'Save Vacancy',
        cancel: 'Cancel',
        editTitle: 'Edit Vacancy',
        createTitle: 'Create New Vacancy',
        locationOptions: {
          onsite: 'On-site',
          remote: 'Remote',
          hybrid: 'Hybrid'
        },
        typeOptions: {
          fullTime: 'Full-Time',
          partTime: 'Part-Time',
          project: 'Project'
        }
      }
    },
    blueprints: {
      selection: 'Selection blueprints',
      vacancy: 'Vacancy blueprints',
      selectionList: 'Selection blueprints',
      vacancyList: 'Vacancy blueprints',
      empty: 'No blueprints yet.',
      stagesCount: '{{count}} stages',
      vacancyFields: 'Vacancy template'
    },
    settings: {
      title: 'Platform users',
      subtitle: 'Create accounts and control administrative access.',
      addUser: 'Add user',
      editUser: 'Edit user',
      user: 'User',
      role: 'Role',
      status: 'Status',
      lastSignIn: 'Last sign-in',
      actions: 'Actions',
      fullName: 'Full name',
      email: 'Email',
      password: 'Password',
      newPassword: 'New password',
      passwordOptional: 'Leave blank to keep the existing password',
      save: 'Save',
      superAdmin: 'Super admin',
      adminRole: 'Admin',
      active: 'Active',
      suspended: 'Suspended',
      you: 'You',
      edit: 'Edit',
      suspend: 'Suspend',
      activate: 'Activate',
      delete: 'Delete',
      loading: 'Loading users...',
      noUsers: 'No platform users found.',
      validEmail: 'Enter a valid email address.',
      passwordMinimum: 'Password must contain at least 8 characters.',
      loadFailed: 'Could not load platform users.',
      actionFailed: 'The user action failed.',
      userCreated: 'User created successfully.',
      userUpdated: 'User updated successfully.',
      userSuspended: 'User suspended.',
      userActivated: 'User activated.',
      userDeleted: 'User deleted.',
      suspendConfirm: 'Suspend {{email}}?',
      activateConfirm: 'Activate {{email}}?',
      deleteConfirm: 'Permanently delete {{email}}? This cannot be undone.'
    },
    selection: {
      loading: 'Loading selection...',
      applicants: 'Accepted applicants',
      total: 'total',
      view: 'View',
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      code: 'Code',
      actions: 'Actions',
      codeRefresh: 'Generate code',
      codeGenerated: 'Candidate code generated.',
      codeFailed: 'Could not generate code. Please try again.',
      codePartial: 'Some codes could not be generated.',
      stageLabel: 'Stage',
      meetModeLabel: 'Meeting link mode',
      meetModeAuto: 'Auto (slots)',
      meetModeManual: 'Manual',
      manualLinksTitle: 'Manual meeting links',
      manualLinksHint: 'Only pass candidates need a link.',
      manualLinkPlaceholder: 'Paste meeting link',
      manualLinksEmpty: 'Select pass candidates to add links.',
      visitLocation: 'Visit location',
      visitLocationPlaceholder: 'Enter address or meeting point',
      slotsTitleStage: 'Stage {{stage}} time slots',
      slotsSubtitleStage: 'Create time slots (GMT+4).',
      blueprintsTitle: 'Selection blueprints',
      blueprintsSubtitle: 'Apply or save selection flows.',
      selectBlueprint: 'Select blueprint',
      selectBlueprintPlaceholder: 'Create from blank',
      applyBlueprint: 'Apply blueprint',
      saveBlueprint: 'Save blueprint',
      blueprintNamePlaceholder: 'New blueprint name',
      blueprintApplied: 'Blueprint applied.',
      blueprintApplyFailed: 'Failed to apply blueprint.',
      blueprintSaved: 'Blueprint saved.',
      blueprintSaveFailed: 'Failed to save blueprint.',
      blueprintNameRequired: 'Enter a unique blueprint name.',
      stagesTitle: 'Stages',
      stagesSubtitle: 'Drag to reorder, add or remove stages.',
      addStage: 'Add stage',
      stageAddFailed: 'Failed to add stage.',
      stageRemoveConfirm: 'Remove this stage?',
      stageRemoveFailed: 'Failed to remove stage.',
      stageOrderFailed: 'Failed to reorder stages.',
      stageType: 'Stage type',
      stageTypeTask: 'Task',
      stageTypeOnline: 'Online interview',
      stageTypeVisit: 'Visit',
      stageTypeCustom: 'Custom',
      enableSlots: 'Enable time slots',
      applyBlueprintConfirm: 'Applying a blueprint will replace current stages. Continue?',
      stageDefault: 'Stage {{number}}',
      removeStage: 'Remove stage',
      slotsTitle: 'Stage 2 slots',
      slotsSubtitle: 'Create interview slots (GMT+4).',
      slotsCount: 'Total slots',
      startDate: 'Start date',
      endDate: 'End date',
      startTime: 'Start time',
      endTime: 'End time',
      slotDuration: 'Slot length (minutes)',
      slotsCreate: 'Create slots',
      slotsCreating: 'Creating...',
      slotsInvalid: 'Please check the date/time range.',
      slotsCreated: 'Slots created.',
      slotsFailed: 'Failed to create slots.',
      slotsPreview: 'Upcoming slots preview',
      slotsTimezone: 'GMT+4',
      slotsPreviewEmpty: 'No slots yet.',
      stage1: { title: 'Step 1 - Mini Task' },
      stage2: { title: 'Step 2 - Interview' },
      stage3: { title: 'Step 3 - Visit' },
      stageTitlePlaceholder: 'Stage title',
      successText: 'Success message',
      failText: 'Fail message',
      meetLink: 'Google Meet link',
      saveDraft: 'Save draft',
      saving: 'Saving...',
      send: 'Send',
      sending: 'Sending...',
      uploadHint: 'Drag & drop files here or click to upload',
      uploading: 'Uploading...'
    }
  },
  footer: {
    about: 'About Us',
    rights: 'All rights reserved',
    poweredBy: 'Powered by Gstore',
    delivery: 'Delivery',
    warranty: 'Warranty',
    rating: 'Rating',
    contact: 'Contact'
  },
  results: {
    defaultTitle: 'Application received',
    defaultText:
      'We have received your resume and consider you an interesting candidate. We are currently reviewing other applications; as soon as the selection process moves to the next stage, we will notify you via email and SMS. Thank you for your interest.',
    visitLocation: 'Visit location',
    getDirections: 'Get directions',
    slots: {
      title: 'Pick an interview slot',
      titleVisit: 'Pick a visit slot'
    }
  }
};
